import { readCookieItem } from '../../../shared/utils/commonUtils';

const fireLinkTrust = (orderId) => {
  const clickId = readCookieItem('affiliate', 'ltclickid');
  const cid = readCookieItem('affiliate', 'ltcmp');
  const MerchantReferenceID = orderId || '';
  if (clickId && cid) {
    const img = new Image();
    img.src = `https://www.tantracking.com/pixel.track?CID=${ cid
         }&MerchantReferenceID=${ MerchantReferenceID }&ClickID=${ clickId}`;
  }
};

export default fireLinkTrust;
